// user
export const SET_USER = 'SET_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'
// friend
export const SET_EDIT_MESSAGE = 'SET_EDIT_MESSAGE'
export const SET_LAST_MESSAGE = 'SET_LAST_MESSAGE'
export const ACCEPT_MESSAGE = 'ACCEPT_MESSAGE'
export const REJECT_MESSAGE = 'REJECT_MESSAGE'
export const ADD_FRIEND = 'ADD_FRIEND'
export const SET_FRIEND_LIST = 'SET_FRIEND_LIST'
export const SET_MESSAGE_READ = 'SET_MESSAGE_READ'
export const SET_APPLY = 'SET_APPLY'
export const ADD_APPLY = 'ADD_APPLY'
export const DELETE_APPLY = 'DELETE_APPLY'

export const ADD_CURR_FRIEND_MESSAGE = 'ADD_CURR_FRIEND_MESSAGE'

export const CLEAR_FRIEND = 'CLEAR_FRIEND'
export const CLEAR_USER = 'CLEAR_USER'

export const SET_FRIEND_READ_INFO = 'SET_FRIEND_READ_INFO'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js